var _path, _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0.43103C0.89 0.43103 0 1.29144 0 2.36453V15.899C0 16.9721 0.89 17.8325 2 17.8325H16C17.11 17.8325 18 16.9721 18 15.899V2.36453C18 1.29144 17.11 0.43103 16 0.43103H2ZM2 2.36453H16V15.899H2V2.36453ZM4 6.23153V4.29803H14V6.23153H4ZM4 8.16503V10.0985H14V8.16503H4ZM4 13.9655V12.032H11V13.9655H4Z",
    fill: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0.43103C0.89 0.43103 0 1.29144 0 2.36453V15.899C0 16.9721 0.89 17.8325 2 17.8325H16C17.11 17.8325 18 16.9721 18 15.899V2.36453C18 1.29144 17.11 0.43103 16 0.43103H2ZM2 2.36453H16V15.899H2V2.36453ZM4 6.23153V4.29803H14V6.23153H4ZM4 8.16503V10.0985H14V8.16503H4ZM4 13.9655V12.032H11V13.9655H4Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.43103,
    width: 18,
    height: 17.4015,
    fill: "#503E9D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/Receipt.bb34e586f3374cbbcac00375039c452b.svg";
export { ForwardRef as ReactComponent };